import { getAuth, isSignInWithEmailLink, updateEmail, User, signOut } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import React, { useEffect, useRef } from 'react'
import { signInWithEmailLink } from '@firebase/auth'
import { Toast } from 'antd-mobile'
import { setCookie } from 'react-use-cookie'
import HomeLoading from '../pages/loading/HomeLoading'

export const ChangeEmailCallback: React.FC = () => {
  const auth = getAuth()
  const navigate = useNavigate()

  const ref = useRef(false)

  useEffect(() => {
    if (!ref.current && isSignInWithEmailLink(auth, window.location.href)) {
      ref.current = true
      const url = new URL(window.location.href)
      const email = url.searchParams.get('email') as string
      const newEmail = url.searchParams.get('newEmail') as string
      signInWithEmailLink(auth, email, window.location.href)
        .then(async ({ user }) => {
          setCookie('uid', user.uid, { path: '/' })
          updateEmail(auth.currentUser as User, newEmail)
            .then(() => {
              Toast.show('Email updated!')
              navigate('/')
            })
            .catch((error) => {
              Toast.show(error.message)
              signOut(auth).then(() => {
                setCookie('deviceId', '')
                setCookie('uid', '')
                setCookie('deviceName', '')
                setCookie('organization', '')
                setCookie('email', '')
              })
            })
        })
        .catch(async (error) => {
          Toast.show(error.message)
          navigate('/login')
          throw new Error(error.message)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <HomeLoading />
}
